import { render, staticRenderFns } from "./VerbTensesForm.vue?vue&type=template&id=e9fde0a0&scoped=true&lang=pug&"
import script from "./VerbTensesForm.vue?vue&type=script&lang=js&"
export * from "./VerbTensesForm.vue?vue&type=script&lang=js&"
import style0 from "./VerbTensesForm.vue?vue&type=style&index=0&id=e9fde0a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fde0a0",
  null
  
)

export default component.exports